import {ShapeFreeForm} from "../core/tools/freeeDraw/ShapeFreeForm";

const toolsControllers = {
  shapeFreeForm: new ShapeFreeForm()
};

export default toolsControllers
